// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,400;0,700;1,400;1,700&family=Rowdies:wght@300;400;700&&family=Rubik:ital,wght@0,300..900;1,300..900&family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-light: #f4f9ff;
  --color-white: #ffffff;
  --color-white-2: #fbfcfe;
  --color-primary: #1f68d6;
  --color-primary-2: #3b7ee3;
  --color-primary-3: #ccedff;
  --color-primary-4: #003c97;
  --color-primary-7: #c1daff;
  --color-primary-8: #97c1ff;
  --color-primary-09: #ccedff;
  --color-mima-light: #eef2f5;
  --color-error: #e12f2f;
  --color-success: #66b032;
  --color-green: #569755;
  --color-green-2: #92e391;
  --color-green-3: #d3eace;
  --color-yellow: #e7d788;
  --color-yellow-2: #ffaa00;
  --color-yellow-3: #8f4f00;
  --color-light-red: #f7d1cd;
  --color-deep-red: #9f0000;
  --color-grey: #b3b3c5;
  --color-grey-2: #d1d1d1;
  --color-grey-3: #e0e9f3;
  --color-grey-4: #f9f9fa;
  --color-grey-5: #ebebf5;
  --color-grey-6: #eaecef;
  --color-grey-7: #fafafa;
  --color-grey-8: #707a8a;
  --color-table-grey: #fafafc;
  --color-table-grey-1: #f4f4fc;
  --color-dark: #252624;
  --color-dark-2: #1a1a42;
  --color-dark-3: #696365;
  --color-dark-6: #2a2828;
  --color-disabled: #c0c0c0;
  --color-light-blue: #ebf2ff;
  --color-light-blue-2: #d4e5ff;
  --color-light-blue-3: #e7f3fe;
  --color-dark-yellow: #7e6e1f;
  --color-light-brown: #f4f5f6;
  --color-light-green: #e4ffec;
  --color-light-yellow: #fff5d7;
  --color-light-red: #ffe8e8;
  --color-light-grey: #f3f3ff;
  --color-admin: #112855;
  --color-admin-2: #071530;
  --color-admin-3: #020710;
  --color-fash-primary: #f5cc16;
  --color-fash-primary-2: #c4a108;
  --color-fash-primary-3: #927700;
  --color-fash-primary-4: #f5e8b0;
  --color-fash-black: #0c090d;
  --color-fash-black-2: #312d33;
  --color-purple: #6a3c8f;
  --color-purple-1: #430d6e;
  --color-fash-green: #cbebca;
  --color-fash-green-1: #ebf2e9;
  --color-fash-green-2: #035e00;
  --color-fash-green-3: #023300;
  --color-fash-wine: #824670;
  --color-moneyex-primary: #25c900;
  --color-moneyex-primary-2: #6bf04d;
  --color-moneyex-primary-3: #305627;
  --color-moneyex-primary-4: #0a2404;
  --default-font-size: 1.8rem;
  --default-font-h1: 6.4rem;
  --default-font-h2: 4rem;
  --default-font-h3: 3.2rem;
  --default-font-subtitle: 2.4rem;
  --default-font-small: 1.4rem;
  --default-font-xsmall: 1.2rem;
  --primary-font: "Montserrat", -apple-system, BlinkMacSystemFont, "Segoe UI",
    "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
    "Helvetica Neue", sans-serif;
  --secondary-font: "Rowdies", "Segoe UI", "Roboto", "Oxygen", "Ubuntu",
    "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  --tertiary-font: "Rubik", "Segoe UI", "Roboto", "Oxygen", "Ubuntu",
    "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
}

*,
*::before,
*::after {
  margin: 0;
  padding: 0;
  box-sizing: inherit;
}

html {
  box-sizing: border-box;
  font-size: 62.5%;
  /* 1rem = 10px the html fontsize determines the value of one rem */
}
@media only screen and (max-width: 62.5em) {
  html {
    font-size: 56.25%;
  }
}
@media only screen and (max-width: 22.5em) {
  html {
    font-size: 50%;
  }
}

body {
  background-color: var(--color-white);
  background-size: cover;
  background-repeat: no-repeat;
  font-family: var(--primary-font);
  font-weight: 400;
  font-size: var(--default-font-small);
  line-height: 2.2rem;
  color: var(--color-dark);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
  position: absolute;
  left: 0px;
  top: 0px;
  right: 0px;
  bottom: 0px;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

@tailwind base;
@tailwind components;
@tailwind utilities;
@layer components {
  .action-text {
    @apply underline cursor-pointer text-[#1f68d6] font-bold;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/variables/_variables.scss","webpack://./src/index.scss"],"names":[],"mappings":"AAAA;EAEE,sBAAA;EACA,sBAAA;EACA,wBAAA;EAEA,wBAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EAEA,sBAAA;EACA,wBAAA;EACA,sBAAA;EACA,wBAAA;EACA,wBAAA;EACA,uBAAA;EACA,yBAAA;EACA,yBAAA;EACA,0BAAA;EACA,yBAAA;EAEA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,2BAAA;EACA,6BAAA;EAIA,qBAAA;EAEA,uBAAA;EACA,uBAAA;EACA,uBAAA;EAEA,yBAAA;EACA,2BAAA;EACA,6BAAA;EACA,6BAAA;EAEA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;EACA,0BAAA;EACA,2BAAA;EAEA,sBAAA;EACA,wBAAA;EACA,wBAAA;EAEA,6BAAA;EACA,+BAAA;EACA,+BAAA;EACA,+BAAA;EACA,2BAAA;EACA,6BAAA;EAEA,uBAAA;EACA,yBAAA;EAEA,2BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EAEA,0BAAA;EAEA,gCAAA;EACA,kCAAA;EACA,kCAAA;EACA,kCAAA;EAGA,2BAAA;EACA,yBAAA;EACA,uBAAA;EACA,yBAAA;EACA,+BAAA;EACA,4BAAA;EACA,6BAAA;EAGA;;gCAAA;EAGA;wEAAA;EAEA;wEAAA;ACjBF;;AA7EA;;;EAGE,SAAA;EACA,UAAA;EACA,mBAAA;AAgFF;;AA7EA;EACE,sBAAA;EACA,gBAAA;EAEA,kEAAA;AA+EF;AAzEE;EAVF;IAWI,iBAAA;EA4EF;AACF;AA1EE;EAdF;IAeI,cAAA;EA6EF;AACF;;AAtEA;EACE,oCAAA;EACA,sBAAA;EACA,4BAAA;EACA,gCAAA;EACA,gBAAA;EACA,oCAAA;EACA,mBAAA;EACA,wBAAA;EAEA,mCAAA;EACA,kCAAA;EAEA,iBAAA;EAEA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;AAsEF;;AAnEA;EACE,+EAAA;AAsEF;;AAlEA,cAAA;AACA,oBAAA;AACA,mBAAA;AAEA;EACE;IACE,wDAAA;EAoEF;AACF","sourcesContent":[":root {\n  //COLORS\n  --color-light: #f4f9ff;\n  --color-white: #ffffff;\n  --color-white-2: #fbfcfe;\n\n  --color-primary: #1f68d6;\n  --color-primary-2: #3b7ee3;\n  --color-primary-3: #ccedff;\n  --color-primary-4: #003c97;\n  --color-primary-7: #c1daff;\n  --color-primary-8: #97c1ff;\n  --color-primary-09: #ccedff;\n  --color-mima-light: #eef2f5;\n\n  --color-error: #e12f2f;\n  --color-success: #66b032;\n  --color-green: #569755;\n  --color-green-2: #92e391;\n  --color-green-3: #d3eace;\n  --color-yellow: #e7d788;\n  --color-yellow-2: #ffaa00;\n  --color-yellow-3: #8f4f00;\n  --color-light-red: #f7d1cd;\n  --color-deep-red: #9f0000;\n\n  --color-grey: #b3b3c5;\n  --color-grey-2: #d1d1d1;\n  --color-grey-3: #e0e9f3;\n  --color-grey-4: #f9f9fa;\n  --color-grey-5: #ebebf5;\n  --color-grey-6: #eaecef;\n  --color-grey-7: #fafafa;\n  --color-grey-8: #707a8a;\n  --color-table-grey: #fafafc;\n  --color-table-grey-1: #f4f4fc;\n\n  // --color-dark: #4a4a68;\n  // --color-dark: #0C090D;\n  --color-dark: #252624;\n\n  --color-dark-2: #1a1a42;\n  --color-dark-3: #696365;\n  --color-dark-6: #2a2828;\n\n  --color-disabled: #c0c0c0;\n  --color-light-blue: #ebf2ff;\n  --color-light-blue-2: #d4e5ff;\n  --color-light-blue-3: #e7f3fe;\n\n  --color-dark-yellow: #7e6e1f;\n  --color-light-brown: #f4f5f6;\n  --color-light-green: #e4ffec;\n  --color-light-yellow: #fff5d7;\n  --color-light-red: #ffe8e8;\n  --color-light-grey: #f3f3ff;\n\n  --color-admin: #112855;\n  --color-admin-2: #071530;\n  --color-admin-3: #020710;\n\n  --color-fash-primary: #f5cc16;\n  --color-fash-primary-2: #c4a108;\n  --color-fash-primary-3: #927700;\n  --color-fash-primary-4: #f5e8b0;\n  --color-fash-black: #0c090d;\n  --color-fash-black-2: #312d33;\n\n  --color-purple: #6a3c8f;\n  --color-purple-1: #430d6e;\n\n  --color-fash-green: #cbebca;\n  --color-fash-green-1: #ebf2e9;\n  --color-fash-green-2: #035e00;\n  --color-fash-green-3: #023300;\n\n  --color-fash-wine: #824670;\n\n  --color-moneyex-primary: #25c900;\n  --color-moneyex-primary-2: #6bf04d;\n  --color-moneyex-primary-3: #305627;\n  --color-moneyex-primary-4: #0a2404;\n\n  // FONT SIZES\n  --default-font-size: 1.8rem;\n  --default-font-h1: 6.4rem;\n  --default-font-h2: 4rem;\n  --default-font-h3: 3.2rem;\n  --default-font-subtitle: 2.4rem;\n  --default-font-small: 1.4rem;\n  --default-font-xsmall: 1.2rem;\n\n  //FONT\n  --primary-font: \"Montserrat\", -apple-system, BlinkMacSystemFont, \"Segoe UI\",\n    \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\",\n    \"Helvetica Neue\", sans-serif;\n  --secondary-font: \"Rowdies\", \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\",\n    \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n  --tertiary-font: \"Rubik\", \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\",\n    \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n}\n\n//COLORS\n$color-light: #f4f9ff;\n$color-white: #ffffff;\n$color-white-2: #fbfcfe;\n\n$color-primary: #1f68d6;\n$color-primary-2: #3b7ee3;\n$color-primary-3: #ccedff;\n$color-primary-4: #003c97;\n$color-primary-7: #c1daff;\n$color-primary-09: #ccedff;\n\n$color-error: #e12f2f;\n$color-success: #66b032;\n$color-green: #569755;\n$color-green-2: #92e391;\n$color-yellow: #e7d788;\n$color-light-red: #f7d1cd;\n\n$color-grey: #b3b3c5;\n$color-grey-2: #d1d1d1;\n$color-grey-3: #e0e9f3;\n$color-grey-4: #d1d1d1;\n$color-grey-6: #9898ab;\n\n$color-dark: #4a4a68;\n$color-dark-3: #696365;\n$color-dark-6: #2a2828;\n\n// FONT\n$default-font-size: 1.8rem;\n$default-font-h1: 6.4rem;\n$default-font-h2: 4rem;\n$default-font-h3: 3.2rem;\n$default-font-subtitle: 2.4rem;\n$default-font-small: 1.4rem;\n\n// SHADOWS\n$shadow-dark: 0 2rem 6rem rgba(0, 0, 0, 0.3);\n$shadow-light: 0 2rem 5rem rgba(0, 0, 0, 0.06);","@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,400;0,700;1,400;1,700&family=Rowdies:wght@300;400;700&&family=Rubik:ital,wght@0,300..900;1,300..900&family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap');\n@import './assets/styles/variables/breakpoints';\n@import './assets/styles/variables/variables';\n\n*,\n*::before,\n*::after {\n  margin: 0;\n  padding: 0;\n  box-sizing: inherit;\n}\n\nhtml {\n  box-sizing: border-box;\n  font-size: 62.5%;\n\n  /* 1rem = 10px the html fontsize determines the value of one rem */\n\n  // @media only screen and (max-width: $bp-1300) {\n  //   font-size: 56.25%; //1rem becomes 9px.\n  // }\n\n  @media only screen and (max-width: $bp-1000) {\n    font-size: 56.25%; //1rem becomes 9px.\n  }\n\n  @media only screen and (max-width: $bp-360) {\n    font-size: 50%; //1rem becomes 8px.\n  }\n\n  // @media only screen and (max-width: $bp-360) {\n  //   font-size: 37.5%; //1rem becomes 6px.\n  // }\n}\n\nbody {\n  background-color: var(--color-white);\n  background-size: cover;\n  background-repeat: no-repeat;\n  font-family: var(--primary-font);\n  font-weight: 400;\n  font-size: var(--default-font-small);\n  line-height: 2.2rem;\n  color: var(--color-dark);\n\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n  min-height: 100vh;\n\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer components {\n  .action-text {\n    @apply underline cursor-pointer text-[#1f68d6] font-bold;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
